/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from 'underscore';
import loader from './loader';

window.google_conversions = [];


const load = loader(() => {
    let d = document;
    let g = d.createElement('script');
    let s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.src = '//www.googleadservices.com/pagead/conversion_async.js';
    g.onload = () => {
        _.each(window.google_conversions, window.google_trackConversion);

        window.google_conversions = {
            push: function () {
                _.each(arguments, window.google_trackConversion);
            }
        };
    };
    s.parentNode.insertBefore(g, s);
});

export default function () {
    load();
    window.google_conversions.push(...arguments);
}

